import Link from 'next/link'
import React from 'react'

import { Button } from '@/components/Button/Button'
import { Icon } from '@/components/Icon/Icon'
import { pxToRem } from '@/shared/styles/themes'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { Box, styled } from '@mui/material'

import { HighlightsSection } from './HighlightsSection'
import { ProductFaqSection } from './ProductFaqSection'
import { ProductReviewsSection } from './ProductReviewsSection'
import { ReviewPhotosGallery } from './ReviewPhotosGallery'
import { STOREFRONT_DATA_MAP } from './storefrontDataMap'

interface StorefrontTrustSignalsProps {
  storySlug: string
}

export const StorefrontTrustSignals: React.FC<StorefrontTrustSignalsProps> = ({ storySlug }) => {
  const data = STOREFRONT_DATA_MAP[storySlug]

  if (!data) return null

  return (
    <>
      {data.highlights && <HighlightsSection highlights={data.highlights} />}
      {data.reviews && <ProductReviewsSection reviews={data.reviews} />}
      {data.reviews?.review_photos && data.reviews.review_photos.length > 0 && (
        <ReviewPhotosGallery photos={data.reviews.review_photos} />
      )}
      {/* {data.social_proof && <SocialProofBanner socialProof={data.social_proof} />} */}
      {data.faq && <ProductFaqSection faq={data.faq} />}

      <StyledCtaWrapper>
        <Link href={`/shop/${storySlug}/personalize`} passHref legacyBehavior>
          <Button primary size="large" component="a">
            Personalise Book
            <Icon icon={faArrowRight} style={{ marginLeft: 8 }} />
          </Button>
        </Link>
      </StyledCtaWrapper>
    </>
  )
}

const StyledCtaWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: ${pxToRem(32)} 0 ${pxToRem(64)};
`
